<template>
  <div id="settingUserList" :class="componentClassName">
    <a-page-heading>ユーザー管理 </a-page-heading>
    <m-section>
      <a-select-field
        v-if="companyID === POINT && authInfo !== 'soOperator' && companyIDList.length !== 0"
        id="selectCompanyID"
        v-model="selectedCompanyID"
        :options="companyIDList"
        :searchable="true"
      />
      <m-action-card
        :id="idName[1]"
        :title="`管理者権限ユーザー （${adminUserList.length}）`"
        icon="user-setting"
        :help="true"
        @help:click="handleManagerUserHelpClick"
      >
        <template #action>
          <a-button
            v-if="canAddUser"
            id="addUserAdminBtn"
            :inline="true"
            variant="fill"
            color="primary"
            size="small"
            icon="plus"
            label="ユーザー追加"
            @click="handleUserAdd('管理者')"
          />
        </template>

        <!-- 一括停止・一括解除 -->
        <m-data-table v-if="canSuspendUser" :fit="true" :data="[{}]" :show-header="false" :class="'m-check-all'">
          <a-data-table-column />
          <a-data-table-column :width="50" />
          <a-data-table-column :width="200" align="center">
            <template #default="">
              <a-text>利用停止一括チェック</a-text>
            </template>
          </a-data-table-column>
          <a-data-table-column :width="50" />
        </m-data-table>
        <m-data-table v-if="canSuspendUser" :fit="true" :data="[{}]" :show-header="false" :class="'m-checkbox'">
          <a-data-table-column />
          <a-data-table-column :width="100" align="center">
            <template #default="">
              <a-checkbox
                id="checkAllCbx"
                v-model="suspendedCheckallModal"
                label="."
                style="color: white"
                :disabled="isSuspensionDisabled"
                @click="handleClickCheckall"
              />
            </template>
          </a-data-table-column>
          <a-data-table-column :width="100" />
        </m-data-table>

        <m-data-table :empty-text="dataTableEmptyText" :fit="true" :data="adminUserList">
          <a-data-table-column prop="userID" :min-width="120" label="メールアドレス" align="left" />
          <a-data-table-column prop="username" :min-width="100" label="名前" align="left">
            <template #default="scope">
              {{ scope.row.username }}
              <!-- <span v-if="scope.row.authInfo === '管理者'">（契約名義者）</span> -->
            </template>
          </a-data-table-column>
          <a-data-table-column prop="departmentInfo" :min-width="100" label="部署" align="left" />
          <a-data-table-column prop="group" :min-width="100" label="着信グループ" align="left" />
          <!-- <a-data-table-column prop="smsNumber" :width="120" label="SMS送信電話番号" align="left" /> -->

          <a-data-table-column type="action" :width="160" align="center" class="a-data-table-column--action">
            <template #default="scope">
              <a-button
                v-if="canEditUser || canPasswordReset"
                :id="'editBtn' + scope.index"
                variant="round"
                size="small"
                label="編集"
                color="grey"
                icon="edit"
                icon-color="black"
                :inline="true"
                @click="handleUserEdit('管理者', scope.row)"
              />
              <a-button
                v-if="canDeleteUser"
                :id="'deleteBtn' + scope.index"
                :disabled="scope.row.authInfo === 'supervisor'"
                variant="round"
                size="small"
                label="削除"
                color="grey"
                icon="trash"
                icon-color="black"
                :inline="true"
                @click="handleRowUserRemove('管理者', scope.row)"
              />
            </template>
          </a-data-table-column>
          <a-data-table-column prop="suspendedStatus" :width="100" label="ステータス" align="left" />
          <a-data-table-column v-if="canSuspendUser" prop="suspendedFlag" :width="100" label="利用停止" align="center">
            <template #default="scope">
              <a-checkbox
                :id="'suspend-cbx' + scope.index"
                v-model="suspendedFlags[scope.row.id]"
                :disabled="isSuspensionDisabled"
                label="."
                style="color: white"
                @click="handleClickCheckbox(scope.row.id)"
              />
            </template>
          </a-data-table-column>
          <a-data-table-column
            v-if="canViewSuspension"
            prop="suspendedDate"
            :width="100"
            label="利用停止日"
            align="left"
          />
        </m-data-table>
      </m-action-card>
    </m-section>

    <m-section>
      <m-action-card
        :id="idName[2]"
        :title="`オペレーター${selectedCompanyID === POINT ? '（運用保守）' : ''}権限ユーザー （${
          operatorUserList.length
        }）`"
        icon="user-setting"
      >
        <template #action>
          <a-button
            v-if="canAddUser"
            id="addUserOperatorBtn"
            :inline="true"
            variant="fill"
            color="primary"
            size="small"
            icon="plus"
            label="ユーザー追加"
            @click="handleUserAdd('オペレーター')"
          />
        </template>

        <m-data-table :empty-text="dataTableEmptyText" :fit="true" :data="operatorUserList">
          <a-data-table-column prop="userID" :min-width="120" label="メールアドレス" align="left" />
          <a-data-table-column prop="username" :min-width="100" label="名前" align="left">
            <template #default="scope">
              {{ scope.row.username }}
              <!-- <span v-if="scope.row.authInfo === '管理者'">（契約名義者）</span> -->
            </template>
          </a-data-table-column>
          <a-data-table-column prop="departmentInfo" :min-width="100" label="部署" align="left" />
          <a-data-table-column prop="group" :min-width="100" label="着信グループ" align="left" />
          <!-- <a-data-table-column prop="smsNumber" :width="120" label="SMS送信電話番号" align="left" /> -->

          <a-data-table-column type="action" :width="160" align="center" class="a-data-table-column--action">
            <template #default="scope">
              <a-button
                v-if="canEditUser || canPasswordReset"
                :id="'operatorEditBtn' + scope.index"
                variant="round"
                size="small"
                label="編集"
                color="grey"
                icon="edit"
                icon-color="black"
                :inline="true"
                @click="handleUserEdit('オペレーター', scope.row)"
              />
              <a-button
                v-if="canDeleteUser"
                :id="'operatorDeleteBtn' + scope.index"
                variant="round"
                size="small"
                label="削除"
                color="grey"
                icon="trash"
                icon-color="black"
                :inline="true"
                @click="handleRowUserRemove('オペレーター', scope.row)"
              />
            </template>
          </a-data-table-column>
          <a-data-table-column prop="suspendedStatus" :width="100" label="ステータス" align="left" />
          <a-data-table-column v-if="canSuspendUser" prop="suspendedFlag" :width="100" label="利用停止" align="center">
            <template #default="scope">
              <a-checkbox
                :id="scope.row.clientName + '-cbx'"
                v-model="suspendedFlags[scope.row.id]"
                :disabled="isSuspensionDisabled"
                label="."
                style="color: white"
                @click="handleClickCheckbox(scope.row.id)"
              />
            </template>
          </a-data-table-column>
          <a-data-table-column
            v-if="canViewSuspension"
            prop="suspendedDate"
            :width="100"
            label="利用停止日"
            align="left"
          />
        </m-data-table>
      </m-action-card>
    </m-section>

    <!--Not use in this phase-->
    <!-- <m-section>
      <m-action-card
        title="SMS認証設定"
        icon="sms-setting"
        :header-border="true"
        :help="true"
        @help:click="handleSMSHelpClick"
      >
        <template #action>
          <a-button
            variant="round"
            size="small"
            label="編集"
            color="grey"
            icon="edit"
            icon-color="black"
            :inline="true"
            @click="handleSMSEdit"
          />
        </template>
        <a-text>{{ smsSettingSummary }}</a-text>
      </m-action-card>
    </m-section> -->

    <m-section v-if="selectedCompanyID === POINT">
      <m-action-card
        :id="idName[3]"
        :title="`オペレーター（SO）権限ユーザー （${soOperatorUserList.length}）`"
        icon="user-setting"
      >
        <template #action>
          <a-button
            v-if="canAddUser"
            id="addUserSoOperatorBtn"
            :inline="true"
            variant="fill"
            color="primary"
            size="small"
            icon="plus"
            label="ユーザー追加"
            @click="handleUserAdd('オペレーター')"
          />
        </template>

        <m-data-table :empty-text="dataTableEmptyText" :fit="true" :data="soOperatorUserList">
          <a-data-table-column prop="userID" :min-width="120" label="メールアドレス" align="left" />
          <a-data-table-column prop="username" :min-width="100" label="名前" align="left">
            <template #default="scope">
              {{ scope.row.username }}
              <!-- <span v-if="scope.row.authInfo === '管理者'">（契約名義者）</span> -->
            </template>
          </a-data-table-column>
          <a-data-table-column prop="departmentInfo" :min-width="100" label="部署" align="left" />
          <a-data-table-column prop="group" :min-width="100" label="着信グループ" align="left" />
          <!-- <a-data-table-column prop="smsNumber" :width="120" label="SMS送信電話番号" align="left" /> -->

          <a-data-table-column type="action" :width="160" align="center" class="a-data-table-column--action">
            <template #default="scope">
              <a-button
                v-if="canEditUser || canPasswordReset"
                :id="'editBtnSoOperatorUserList' + scope.index"
                variant="round"
                size="small"
                label="編集"
                color="grey"
                icon="edit"
                icon-color="black"
                :inline="true"
                @click="handleUserEdit('オペレーター', scope.row)"
              />
              <a-button
                v-if="canDeleteUser"
                :id="'deleteBtnSoOperatorUserList' + scope.index"
                variant="round"
                size="small"
                label="削除"
                color="grey"
                icon="trash"
                icon-color="black"
                :inline="true"
                @click="handleRowUserRemove('オペレーター', scope.row)"
              />
            </template>
          </a-data-table-column>
          <a-data-table-column prop="suspendedStatus" :width="100" label="ステータス" align="left" />
          <a-data-table-column v-if="canSuspendUser" prop="suspendedFlag" :width="100" label="利用停止" align="center">
            <template #default="scope">
              <a-checkbox
                :id="scope.row.clientName + '-cbx'"
                v-model="suspendedFlags[scope.row.id]"
                :disabled="isSuspensionDisabled"
                label="."
                style="color: white"
                @click="handleClickCheckbox(scope.row.id)"
              />
            </template>
          </a-data-table-column>
          <a-data-table-column
            v-if="canViewSuspension"
            prop="suspendedDate"
            :width="100"
            label="利用停止日"
            align="left"
          />
        </m-data-table>
      </m-action-card>
    </m-section>

    <m-section class="m-save-btn-area">
      <m-action-card :id="idName[4]">
        <!-- 利用停止保存 -->
        <m-data-table v-if="canSuspendUser" :fit="true" :data="[{}]" :show-header="false" :class="'m-save-button'">
          <a-data-table-column />
          <a-data-table-column :width="100" align="center">
            <template #default="">
              <a-button
                id="saveSuspensionBtn"
                :disabled="isSuspensionDisabled"
                variant="outlined"
                color="primary"
                @click="handleSaveSuspend()"
                >保存</a-button
              >
            </template>
          </a-data-table-column>
          <a-data-table-column :width="100" />
        </m-data-table>
      </m-action-card>
    </m-section>

    <m-section>
      <m-action-card
        :id="idName[5]"
        title="着信グループ設定"
        icon="phone-incoming-call-block"
        :help="true"
        @help:click="handleGroupSettingHelpClick"
      >
        <template #action>
          <a-button
            v-if="canEditUser"
            id="addGroupBtn"
            :inline="true"
            variant="fill"
            color="primary"
            size="small"
            icon="plus"
            label="グループ追加"
            @click="handleGroupAdd"
          />
        </template>

        <m-data-table :empty-text="dataTableEmptyText" :fit="true" :data="groupList">
          <a-data-table-column prop="id" :width="180" label="着信グループ名" align="left" />
          <a-data-table-column prop="user_count" :min-width="100" label="ユーザー数" align="left">
            <template #default="scope"> {{ scope.row.user_count }} 名 </template>
          </a-data-table-column>

          <a-data-table-column type="action" :width="160" align="center" class="a-data-table-column--action">
            <template #default="scope">
              <a-button
                v-if="canEditUser"
                :id="'editGroup' + scope.row.idTag"
                variant="round"
                size="small"
                label="編集"
                color="grey"
                icon="edit"
                icon-color="black"
                :inline="true"
                @click="handleGroupEdit(scope.row)"
              />
              <a-button
                v-if="canEditUser"
                :id="'deleteGroup' + scope.row.idTag"
                variant="round"
                size="small"
                label="削除"
                color="grey"
                icon="trash"
                icon-color="black"
                :inline="true"
                @click="handleRowGroupRemove(scope.row)"
              />
            </template>
          </a-data-table-column>
        </m-data-table>
      </m-action-card>
    </m-section>
  </div>

  <teleport to="body">
    <o-modal
      id="settingUserList_removeModal"
      v-model:visible="removeUserDialogVisible"
      class="o-modal-remove-user-confirmation"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      @close="handleCancelRemoveUser"
    >
      <template #title> ユーザー削除 </template>
      <a-text :center="true">
        <!-- eslint-disable -->
        <span v-html="removeUserConfirmationMessageText" />
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button
          id="removeUserDialogCancelBtn"
          variant="outlined"
          color="primary"
          label="いいえ"
          size="small"
          @click="handleCancelRemoveUser"
        />
        <a-button
          id="removeUserDialogOKBtn"
          variant="block"
          color="primary"
          label="はい"
          size="small"
          @click="handleConfirmRemoveUser"
        />
      </template>
    </o-modal>
  </teleport>

  <teleport to="body">
    <o-modal
      id="settingUserList_removeGroupModal"
      v-model:visible="removeGroupDialogVisible"
      class="o-modal-remove-group-confirmation"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      @close="handleCancelRemoveGroup"
    >
      <template #title> グループ削除 </template>
      <a-text :center="true">
        <!-- eslint-disable -->
        <span v-html="removeGroupConfirmationMessageText" />
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button
          id="removeGroupDialogCancelBtn"
          variant="outlined"
          color="primary"
          label="いいえ"
          size="small"
          @click="handleCancelRemoveGroup"
        />
        <a-button
          id="removeGroupDialogOKBtn"
          variant="block"
          color="primary"
          label="はい"
          size="small"
          @click="handleConfirmRemoveGroup"
        />
      </template>
    </o-modal>
  </teleport>

  <teleport to="body">
    <o-modal
      id="settingUserList_removeComfirmModal"
      v-model:visible="forceRemoveGroupDialogVisible"
      class="o-modal-remove-group-confirmation"
      footer-variant="confirmation"
      width="530px"
      :footer-shadow="false"
      @close="handleConfirmForceRemoveGroup(false)"
    >
      <template #title> グループ削除 </template>
      <a-text :center="true">
        <!-- eslint-disable -->
        <span
          >こちらのグループは着信フロー設定で使用されていますが削除しますか？<br />削除すると正常に着信が受けられなくなる可能性があります。</span
        >
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button
          id="forceRemoveGroupDialogCancelBtn"
          variant="outlined"
          color="primary"
          label="キャンセル"
          size="small"
          @click="handleConfirmForceRemoveGroup(false)"
        />
        <a-button
          id="forceRemoveGroupDialogOKBtn"
          variant="block"
          color="primary"
          label="OK"
          size="small"
          @click="handleConfirmForceRemoveGroup(true)"
        />
      </template>
    </o-modal>
  </teleport>

  <teleport to="body">
    <o-modal
      id="settingUserList_helpModal"
      v-model:visible="helpDialogVisible"
      class="o-modal-help-dialog"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      :close-on-click-modal="false"
      @close="handleCloseHelpDialog"
    >
      <template #title>{{ currentHelpMessageTitle }}</template>
      <a-text>
        <!-- eslint-disable -->
        <span v-html="currentHelpMessageText" />
        <!-- eslint-enable -->
      </a-text>
    </o-modal>
  </teleport>

  <!-- Confirm, Error Modal -->
  <teleport to="body">
    <o-modal
      id="settingUserList_removeNumberModal"
      v-model:visible="resultModalVisible"
      class="o-modal-remove-phone-number-confirmation"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <template #title>{{ resultModalTitle }}</template>
      <a-text>
        <!-- eslint-disable -->
        <span v-html="resultModalContent" />
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button
          id="resultModalOKBtn"
          variant="block"
          color="primary"
          label="OK"
          size="small"
          @click="handleCloseModal"
        />
      </template>
    </o-modal>
  </teleport>
  <!-- Modal for suspend user -->
  <teleport to="body">
    <o-modal
      id="settingUserList_removeNumberComfirmModal"
      v-model:visible="suspendModalVisible"
      class="o-modal-remove-phone-number-confirmation"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <!-- <template #title>{{ suspendModalTitle }}</template> -->
      <a-text>
        <!-- eslint-disable-next-line vue/no-v-html -->
        <span v-html="suspendModalContent"></span>
      </a-text>
      <template #footer>
        <a-button
          id="suspendModalCancelBtn"
          variant="outlined"
          color="primary"
          label="いいえ"
          size="small"
          @click="handleSuspendModalCancel"
        />
        <a-button
          id="suspendModalOKBtn"
          variant="block"
          color="primary"
          label="はい"
          size="small"
          @click="handleSuspendModalOK"
        />
      </template>
    </o-modal>
  </teleport>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import APageHeading from '@/components/atoms/page-heading';
import MActionCard from '@/components/molecules/action-card';
import AButton from '@/components/atoms/button';
import ASelectField from '@/components/atoms/select-field';
import AText from '@/components/atoms/text';
import MSection from '@/components/molecules/section';
import MDataTable from '@/components/molecules/data-table';
import ADataTableColumn from '@/components/atoms/data-table-column';
import OModal from '@/components/organisms/modal';
import * as Handlebars from 'handlebars';

import { utils } from '@/common/utils.js';
import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';
import {
  MAX_GROUP_PER_COMPANY,
  MAX_USER_PER_COMPANY,
  MAX_USER_PER_COMPANY_TRIAL,
  MAX_USER_COM_COMPANY,
  PERMISSIONS_FRONTEND,
} from '@/libs/constants';
import { POINT } from '@/libs/constants';
import { chkTrialCompanyID } from '@/libs/utils';
const SAVING_SUSPENSION = 'saving-suspension';
const CHECK_ALL_LABEL = 'check-all';
const UNCHECK_ALL_LABEL = 'uncheck-all';

export default {
  name: 't-setting-user-list',
  components: {
    APageHeading,
    MSection,
    MActionCard,
    AButton,
    ASelectField,
    AText,
    MDataTable,
    ADataTableColumn,
    OModal,
  },
  mixins: [customRequest],
  props: {
    class: {
      type: String,
      default: '',
    },
    handleSMSEdit: {
      type: Function,
      default: () => {},
    },
    companyID: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      //USER
      userToRemove: {
        userID: '',
        data: null,
      },
      userList: [],
      selectedCompanyID: '',
      adminUserList: [],
      operatorUserList: [],
      soOperatorUserList: [],
      operatorAuth: ['オペレーター', 'operator'],
      adminAuth: ['管理者', 'manager', 'supervisor'],
      soOperatorAuth: ['soOperator'],
      noSuspensionAuth: ['オペレーター', 'operator', 'soOperator'],
      removeUserDialogVisible: false,
      dataTableEmptyText: '', // 登録がありません
      //GROUP
      removeGroupDialogVisible: false,
      groupToRemove: {
        data: null,
      },
      groupTitleHelpMessage: '着信グループとは',
      groupBodyHelpMessage:
        '着信を受けるユーザーグループを作成できる仕組みです。一つのグループには最大10名まで登録することができます。',
      removeGroupConfirmationMessage: `{{ id }} を削除しますか？`,
      groupList: [],
      maxGroup: MAX_GROUP_PER_COMPANY,
      //SMS
      // smsTitleHelpMessage: 'SMS認証とは',
      // smsBodyHelpMessage: '本人確認を正しく行うために、ユーザーのスマートフォンや携帯電話にSMS（ショートメッセージ）を送信し、そこに記載された一時的な確認コードをWebで入力することで認証する仕組みです。',
      //管理者権限ユーザー
      managerTitleHelpMessage: 'ユーザー管理画面について',
      managerBodyHelpMessage: `マスタ管理者アカウントは削除することができません。
        <br />
        マスタ管理者の削除については以下のNTTコミュニケーションズのサポートサイトからお問い合わせをお願いします。
        <br />
        <a href="https://support.ntt.com/ccaas" target="_blank">https://support.ntt.com/ccaas</a>`,
      //Modal
      helpDialogVisible: false,
      currentHelpType: '',
      // smsSettingSummary: '新規登録時にSMS認証を必須にする',
      resultModalVisible: false,
      resultModalTitle: '',
      resultModalContent: '',
      companyIDList: [],
      forceRemoveGroupDialogVisible: false,
      forceRemoveGroupName: '',
      authInfo: this.$store.state.user.authInfo,
      POINT,
      suspendedFlags: {},
      adminSuspendedFlags: [],
      operatorSuspendedFlags: [],
      soOperatorSuspendedFlags: [],
      // Suspend
      suspendModalVisible: false,
      suspendModalTitle: '',
      suspendModalContent: '',
      suspendConfimingID: null,
      suspendModalLabel: null,
      suspendData: {},
      suspendedCheckallModal: false,
      isUserDataReady: false,
      idName: [],
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-setting-user-list');
      return `${baseClassName} ${this.class}`.trim();
    },
    removeUserConfirmationMessageText() {
      if (this.userToRemove.data) {
        return chkTrialCompanyID(this.companyID)
          ? messageContent.notifyUserDeleteTrial(this.userToRemove.data.userID)
          : messageContent.notifyUserDelete(this.userToRemove.data.userID);
      } else {
        return '';
      }
    },
    removeGroupConfirmationMessageText() {
      if (this.groupToRemove.data) {
        return this.convertMessage(this.removeGroupConfirmationMessage, this.groupToRemove.data.id);
      } else {
        return this.removeGroupConfirmationMessage;
      }
    },
    currentHelpMessageTitle() {
      if (this.currentHelpType === 'sms') {
        return this.smsTitleHelpMessage;
      } else if (this.currentHelpType === 'manager') {
        return this.managerTitleHelpMessage;
      } else {
        return this.groupTitleHelpMessage;
      }
    },
    currentHelpMessageText() {
      if (this.currentHelpType === 'sms') {
        return this.smsBodyHelpMessage;
      } else if (this.currentHelpType === 'manager') {
        return this.managerBodyHelpMessage;
      } else {
        return this.groupBodyHelpMessage;
      }
    },
    canListUser() {
      if (this.companyID === POINT && this.authInfo === 'soOperator' && this.selectedCompanyID !== POINT) {
        return false;
      } else {
        return PERMISSIONS_FRONTEND['Idmgmt'][this.authInfo];
      }
    },
    canAddUser() {
      if (this.companyID === POINT && this.authInfo === 'manager' && this.selectedCompanyID === POINT) {
        return false;
      } else if (this.companyID === POINT && this.authInfo === 'operator' && this.selectedCompanyID === POINT) {
        return false;
      } else if (this.companyID !== POINT && this.authInfo === 'manager') {
        return false;
      } else if (this.companyID !== POINT && this.authInfo === 'operator') {
        return false;
      } else {
        return PERMISSIONS_FRONTEND['userAdd'][this.authInfo];
      }
    },
    canDeleteUser() {
      return this.canAddUser;
    },
    canEditUser() {
      if (this.companyID === POINT && this.authInfo === 'operator' && this.selectedCompanyID === POINT) {
        return false;
      } else if (this.companyID === POINT && this.authInfo === 'soOperator') {
        return true;
      } else if (this.companyID !== POINT && this.authInfo === 'operator') {
        return false;
      } else {
        return PERMISSIONS_FRONTEND['userEdit'][this.authInfo];
      }
    },
    canPasswordReset() {
      if (this.companyID === POINT && this.authInfo === 'soOperator' && this.selectedCompanyID !== POINT) {
        return false;
      } else if (this.companyID !== POINT && this.authInfo === 'operator') {
        return false;
      } else {
        return PERMISSIONS_FRONTEND['userEdit'][this.authInfo];
      }
    },
    maxUser() {
      const isTrial = chkTrialCompanyID(this.companyID);
      return this.selectedCompanyID === POINT
        ? MAX_USER_COM_COMPANY
        : isTrial
        ? MAX_USER_PER_COMPANY_TRIAL
        : MAX_USER_PER_COMPANY;
    },
    maxTrialUser() {
      return MAX_USER_PER_COMPANY_TRIAL;
    },
    canViewSuspension() {
      return this.companyID === POINT;
    },
    canSuspendUser() {
      return this.companyID === POINT;
    },
    suspendedCheckall() {
      for (const id in this.suspendedFlags) {
        if (!this.suspendedFlags[id]) return false;
      }
      return true;
    },
    isSuspensionDisabled() {
      return (
        !this.isUserDataReady || (this.selectedCompanyID === POINT && this.noSuspensionAuth.includes(this.authInfo))
      );
    },
  },
  watch: {
    selectedCompanyID: async function (newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        this.isUserDataReady = false;
        if (this.companyID === POINT && this.selectedCompanyID !== this.$route.query.companyID) {
          await this.$router.push({ query: { companyID: this.selectedCompanyID } });
        }
        await this.handlerGetGroupList();
        await this.handlerFetchUserData();
      }
      if (!newValue) {
        this.selectedCompanyID = oldValue;
      }
    },
    suspendedFlags: {
      handler: function () {
        this.suspendedCheckallModal = this.suspendedCheckall;
      },
      deep: true,
    },
  },
  async created() {
    for (let i = 1; i <= 5; i++) {
      this.idName[i] = 'h4-idmgmt' + i;
    }

    if (this.companyID === POINT && this.authInfo !== 'soOperator') {
      await this.fetchCompanyIDListHandler();
    }
    this.selectedCompanyID = this.$route.query.companyID ? this.$route.query.companyID : this.companyID;
    if (!this.canListUser) {
      this.$router.push({ path: '/permission-denied' });
    }
  },
  methods: {
    handleRowUserRemove(authInfo, data) {
      // open confirmation modal
      this.userToRemove.authInfo = authInfo;
      this.userToRemove.data = data;
      this.removeUserDialogVisible = true;
    },
    handleConfirmRemoveUser() {
      this.handleUserRemove(this.userToRemove.authInfo, this.userToRemove.data);
      this.resetUserToRemove();
    },
    handleUserRemove(authInfo, data) {
      const self = this;
      const deleteUserIDList = [];
      deleteUserIDList.push({ userID: data.userID, clientName: data.clientName });
      const formDataTmp = {
        companyID: this.$route.query.companyID,
        deleteList: deleteUserIDList,
      };
      this.postRequest('/idmgmt/delete', formDataTmp)
        .then(e => {
          if (e.status === 'success') {
            self.showInfoModal(messageContent.userDeleted);
            self.handlerFetchUserData();
          } else if (e.status === 'user mismatch') {
            self.showErrorModal(messageContent.changedEmailUpdateScreen);
          } else {
            self.showErrorModal(messageContent.requireTry('ユーザー削除'));
          }
        })
        .catch(() => {
          self.showErrorModal(messageContent.requireTry('ユーザー削除'));
        });
    },
    handleCancelRemoveUser() {
      this.resetUserToRemove();
    },
    resetUserToRemove() {
      this.removeUserDialogVisible = false;
      this.userToRemove.authInfo = '';
      this.userToRemove.data = null;
    },
    handleSMSHelpClick() {
      this.currentHelpType = 'sms';
      this.helpDialogVisible = true;
    },
    handleGroupSettingHelpClick() {
      this.currentHelpType = 'group';
      this.helpDialogVisible = true;
    },
    handleManagerUserHelpClick() {
      this.helpDialogVisible = true;
      this.currentHelpType = 'manager';
    },
    handleRowGroupRemove(data) {
      this.groupToRemove.data = data;
      this.removeGroupDialogVisible = true;
    },
    handleConfirmRemoveGroup() {
      this.handleGroupRemove(this.groupToRemove);
      this.resetGroupToRemove();
    },
    handleCancelRemoveGroup() {
      this.resetGroupToRemove();
    },
    resetGroupToRemove() {
      this.removeGroupDialogVisible = false;
      this.groupToRemove.data = null;
    },
    handleCloseHelpDialog() {
      this.helpDialogVisible = false;
      this.currentHelpType = '';
    },
    handlerFetchUserData: async function () {
      this.isUserDataReady = false;
      await this.postRequest('/idmgmt/getuserlist', { companyID: this.$route.query.companyID })
        .then(e => {
          this.userList = e.data;
          // 利用停止一覧判定
          this.suspendedFlags = {};
          for (const id in this.userList) {
            this.userList[id]['id'] = id;
            this.suspendedFlags[id] = this.userList[id]['suspendedFlag'];
          }
          this.suspendedCheckallModal = this.suspendedCheckall;
          this.operatorUserList = this.filterUserList(this.userList, 'authInfo', this.operatorAuth);
          this.soOperatorUserList = this.filterUserList(this.userList, 'authInfo', this.soOperatorAuth);
          this.adminUserList = this.filterUserList(this.userList, 'authInfo', this.adminAuth);
          for (let i = 0; i < this.adminUserList.length; i++) {
            this.adminUserList[i].username = this.adminUserList[i].username.replace('_', ' ');
          }
          this.isUserDataReady = true;
        })
        .catch(() => {
          this.showErrorModal(messageContent.requireTry('検索'));
        });
    },
    filterUserList(obj, filter, filterValue) {
      const tempObj = Object.keys(obj).reduce(function (currentObj, key) {
        if (filterValue.includes(obj[key][filter])) {
          currentObj[key] = obj[key];
        }
        return currentObj;
      }, {});
      const self = this;
      //convert object to array;
      const tempArray = [];
      Object.keys(tempObj).map(function (key) {
        const obj = Object.assign({}, tempObj[key]);
        obj.userID = key;
        obj.group = self.mapGroupInfoToUser(obj);
        tempArray.push(obj);
      });
      return tempArray;
    },
    handlerGetGroupList: async function () {
      await this.postRequest('/groupmgmt/getlist', { companyID: this.$route.query.companyID })
        .then(e => {
          this.groupList = e.data;
          for (let i = 0; i < this.groupList.length; i++) {
            this.groupList[i].user_count = this.groupList[i].clientNameList.length;
            this.groupList[i].idTag = i;
          }
        })
        .catch(() => {
          this.showErrorModal(messageContent.requireTry('着信グループ一覧の取得'));
        });
    },
    fetchCompanyIDListHandler: async function () {
      await this.postRequest('/companymgmt/getcompanyidlistCCCOnly', { withPoint: true })
        .then(e => {
          this.companyIDList = e.data;
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('登録ユーザーの取得'));
        });
    },
    async handleUserAdd(authInfo) {
      // 変更SO承認待ちのとき、ユーザIDを追加できない
      const soStatusResult = await this.checkSoStatus();
      if (!soStatusResult) {
        return;
      }

      const tmpCompanyID = this.$route.query.companyID ? this.$route.query.companyID : this.companyID;
      if (utils.chkTrialCompanyID(tmpCompanyID)) {
        if (this.adminUserList.length + this.operatorUserList.length >= this.maxTrialUser) {
          this.showErrorModal(messageContent.requireTrialUserAdd(this.maxTrialUser));
        } else {
          this.$router.push({
            path: '/idmgmt/add',
            query: { companyID: this.$route.query.companyID, authInfo: authInfo },
          });
        }
      } else {
        if (this.adminUserList.length + this.operatorUserList.length >= this.maxUser) {
          this.showErrorModal(messageContent.maxUser(this.maxUser));
        } else {
          this.$router.push({
            path: '/idmgmt/add',
            query: { companyID: this.$route.query.companyID, authInfo: authInfo },
          });
        }
      }
    },
    handleUserEdit(group, row) {
      this.$router.push({
        path: '/idmgmt/edit',
        query: { companyID: this.$route.query.companyID, userID: row.userID },
      });
    },
    handleGroupAdd() {
      if (this.groupList.length >= this.maxGroup) {
        this.showErrorModal(messageContent.maxGroup(this.maxGroup));
      } else {
        this.$router.push({ path: '/groupmgmt/add', query: { companyID: this.$route.query.companyID } });
      }
    },
    handleGroupEdit(row) {
      this.$router.push({
        path: '/groupmgmt/edit',
        query: { companyID: this.$route.query.companyID, groupID: row.id },
      });
    },
    handleGroupRemove(groupToRemove) {
      const group = groupToRemove.data;
      this.deleteGroup({ companyID: this.$route.query.companyID, groupID: group.id });
    },
    deleteGroup(data) {
      this.postRequest('/groupmgmt/delete', data)
        .then(e => {
          if (e.status === 'success') {
            this.showInfoModal(data.groupID + messageContent.incomingGroupDeleted);
            this.handlerGetGroupList();
            this.handlerFetchUserData();
          } else if (e.status === 'usingGroup') {
            this.forceRemoveGroupName = data.groupID;
            this.forceRemoveGroupDialogVisible = true;
          } else {
            this.showErrorModal(messageContent.requireTry('着信グループの削除'));
          }
        })
        .catch(() => {
          this.showErrorModal(messageContent.requireTry('着信グループの削除'));
        });
    },
    handleConfirmForceRemoveGroup(flag) {
      this.forceRemoveGroupDialogVisible = false;
      if (!flag) return;
      // Force delete groupname
      this.deleteGroup({
        companyID: this.selectedCompanyID,
        groupID: this.forceRemoveGroupName,
        isForceRemove: true,
      });
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
    mapGroupInfoToUser(user) {
      const userInGroupList = [];
      this.groupList.map(function (group) {
        if (group.clientNameList.includes(user.clientName)) {
          userInGroupList.push(group.id);
        }
      });
      return userInGroupList.join('、');
    },
    convertMessage(message, newValue) {
      const newMessage = message;
      return newMessage.replace(/\{{(.+?)\}}/g, newValue);
    },
    handleClickCheckall() {
      const val = !this.suspendedCheckall;
      for (const id in this.suspendedFlags) {
        this.suspendedFlags[id] = val;
      }
    },
    handleClickCheckbox(id) {
      this.suspendConfimingID = id;
    },
    showSuspendModal(msg) {
      this.suspendModalVisible = true;
      this.suspendModalContent = msg;
    },
    handleSuspendModalOK() {
      this.suspendModalVisible = false;
      if (this.suspendConfimingID === SAVING_SUSPENSION) {
        // Process for saving the suspension
        this.suspendData.companyID = this.selectedCompanyID;
        this.postRequest('/idmgmt/save-suspension', this.suspendData)
          .then(res => {
            if (res.status === 'success') {
              for (const user of this.adminUserList) {
                if (res.data[user.id]) {
                  user['suspendedDate'] = res.data[user.id]['suspendedDate'];
                  user['suspendedStatus'] = user['suspendedDate'] ? '停止中' : '利用中';
                }
              }
              for (const user of this.operatorUserList) {
                if (res.data[user.id]) {
                  user['suspendedDate'] = res.data[user.id]['suspendedDate'];
                  user['suspendedStatus'] = user['suspendedDate'] ? '停止中' : '利用中';
                }
              }
              for (const user of this.soOperatorUserList) {
                if (res.data[user.id]) {
                  user['suspendedDate'] = res.data[user.id]['suspendedDate'];
                  user['suspendedStatus'] = user['suspendedDate'] ? '停止中' : '利用中';
                }
              }
              this.showInfoModal(messageContent.suspensionSettingSaved);
            } else {
              this.showErrorModal(messageContent.failedToSaveSuspension);
            }
          })
          .catch(e => {
            console.log(e);
            this.showErrorModal(messageContent.failedToSaveSuspension);
          });
      }
    },
    handleSuspendModalCancel() {
      this.suspendModalVisible = false;
      this.suspendedCheckallModal = this.suspendedCheckall;
    },
    handleSaveSuspend() {
      this.suspendConfimingID = SAVING_SUSPENSION;
      this.suspendData = {};
      this.suspendData.data = this.suspendedFlags;
      this.showSuspendModal(`${messageContent.suspendsTheSelectedUser}<br>${messageContent.isThisGood}`);
    },
    checkSoStatus: async function () {
      return await this.postRequest('/contract/checksostatus', {
        companyID: this.companyID === POINT ? this.$route.query.companyID : this.companyID,
      })
        .then(e => {
          if (e.status === 'failed') {
            this.soStatusFlag = true;
            this.showErrorModal(messageContent.alertNowApplying2());
            return false;
          }
          this.soStatusFlag = false;
          return true;
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('契約変更の申請'));
        });
    },
  },
};
</script>
